import { number } from "echarts";
import { IUser } from "./User";

export enum UserRoleAdmin {
    NONE = "NONE",
    Full = "Full",
    Limited = "Limited"
}

export enum UserPermission {
    NONE = "NONE",
    Read = "Read",
    Full = "Full"
}

export enum SectionPermission {
    AgentProfile = "AgentProfile",
    AgentContact = "AgentContact",
    AgentProperties = "AgentProperties",
    AgentPropertiesWebsite = "AgentPropertiesWebsite",
    AgentWebsite = "AgentWebsite",
    Agents = "Agents",
    AgentsWebsite = "AgentsWebsite",
    Properties = "Properties",
    PropertiesWebsite = "PropertiesWebsite",
	CompanyWebsite = "CompanyWebsite",
    Domains = "Domains",
    FileManager = "FileManager",
    CompanyInfo = "CompanyInfo",
    UserPermissions = "UserPermissions",
    Payment = "Payment",
    //BuyDomains = "BuyDomains",
    //BuyTemplates = "BuyTemplates",
    //BuyStorage = "BuyStorage",
    BuyWebsites = "BuyWebsites",
    DeveloperTools = "DeveloperTools"
}

export enum DevSectionPermission {
    TemplateOthers = "TemplateOthers",
    TemplateSelfPublish = "TemplateSelfPublish",
    TemplateSnapshot = "TemplateSnapshot",
    CompanyInfo = "CompanyInfo",
    UserPermissions = "UserPermissions",
    DeveloperTools = "DeveloperTools"
}

export class CompanyUser {
    Id: number;
    UserId: number;
    Email: string;
    Avatar: string;
    FirstName: string;
    LastName: string;
    UserRole: string;
    IsOwner: boolean;
}

export interface IUserPermissionsResponse {
    success: boolean;
    userId: number;
    companyId: number;
    role: UserRoleAdmin;
    permissions: IUserPermissions;
    isOwner: boolean;
    agentId?: number;
    isDevTools: boolean;
}

export interface IPermissionsResponse {
    success: boolean;
    role: UserRoleAdmin;
    permissions: ICompanyUserPermission[];
    isOwner: boolean;
}

export interface ICompanyUserPermissionsResponse extends IPermissionsResponse {
    user: IUser;
    agent: any;
}

export interface ICompanyUserPermission {
    Name: string;
    Type: string;
    Category: string;
    Permission: string;
}

export class CompanyUserPermissionCategory {
    Category: string;
    Permissions: ICompanyUserPermission[];
}

export interface IUserPermissions {
    [key: string]: UserPermission;
}

export class CompanyUserInvite {
    Id: number;
    Email: string;
    Code: string;
    Created: Date;
    CreatedBy: number;
    CreatedByFirstName: string;
    CreatedByLastName: string;
}